import React from 'react';
interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}
export function Label({
  children,
  className = '',
  required,
  ...props
}: LabelProps) {
  return <label className={`block text-sm font-medium text-gray-700 mb-1.5 ${className}`} {...props} data-id="element-109">
      {children}
      {required && <span className="text-red-500 ml-1" data-id="element-110">*</span>}
    </label>;
}